import Button from 'flarum/common/components/Button';
import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';

export default class TicketStatusFilterButton extends Component {
  view() {
    return (
      <Button
        className={`Button SupportTicketFilterButton`}
        onclick={(e) => {
          e.preventDefault();
          this.attrs.onFilterClick();
        }}
        icon={this.attrs.filterIcon}
      >
        {this.attrs.filterLabel
          ? this.attrs.filterLabel
          : app.translator.trans(`v17development-flarum-support.forum.tickets.status.${this.attrs.filterStatus}.title`)}

        {this.attrs.isChecked && <span className={'Flarum-Support-status-remove fa fa-times'}></span>}
      </Button>
    );
  }
}
